module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Mute-6e5b3fd130c914003fc026548487a7d6.svg";